// @flow
import React from 'react'
import { CONDITION_ITEMS } from '../../constants/conditions'
import RangeConditionLabel from './RangeConditionLabel'
import { ConditionName, RangeParams, RangeConditionName } from '../../actions'
import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import { OptionDropdown } from '../../../../view/OptionDropdown'
import { OptionDropdownItem } from '../../../../view/OptionDropdownItem'

type Props = {
  name: RangeConditionName
  open: boolean
  from?: number
  to?: number
  hasError: boolean
  onToggle: (cond: ConditionName) => any
  onRemove: (cond: ConditionName) => any
  onSet: (cond: ConditionName, range: RangeParams) => any
  annotation?: string
  useLabelAnnotation: boolean
}

const MAX_DIGIT = 7

export default class RangeCondition extends React.Component<Props> {
  handleSet(range: RangeParams) {
    this.props.onSet(this.props.name, range)
  }

  handleChange(v: string, end: string) {
    const n = parseInt(v)

    if (
      (!Number.isNaN(n) && !Number.isInteger(n)) ||
      n.toString().length > MAX_DIGIT
    ) {
      return
    }
    const from = this.props.from
    const to = this.props.to

    let range
    if (end === 'from') {
      range = Number.isNaN(n) ? { from: null, to } : { from: n, to }
    } else {
      range = Number.isNaN(n) ? { from, to: null } : { from, to: n }
    }

    this.props.onSet(this.props.name, range)
  }

  handleClickOutside(_e: any) {
    if (this.props.open) {
      this.props.onToggle(this.props.name)
    }
  }

  render() {
    const {
      name,
      annotation,
      useLabelAnnotation,
      from,
      to,
      hasError,
      onRemove,
      onToggle,
    } = this.props
    const options = CONDITION_ITEMS[name].options
    const errorClass = (c: string = '') => (hasError ? `${c} error` : c)

    return (
      <div
        className={errorClass('condition')}
        css={css`
          background-color: ${colors.cyan50};
          border-radius: 50px;
          color: ${colors.white10};
          display: inline-block;
          font-size: 13px;
          position: relative;
          &:last-child {
            margin-right: 5px;
          }
          &.error {
            background-color: ${colors.red50};
          }
        `}
      >
        <RangeConditionLabel
          name={name}
          annotation={useLabelAnnotation ? annotation : null}
          error={hasError}
          from={from}
          to={to}
          onRemove={onRemove}
          onToggle={onToggle}
        />
        <OptionDropdown open={this.props.open}>
          {options.map((option: any, i: any) => (
            <OptionDropdownItem
              key={i}
              idx={i}
              condition={from == option.range.from && to == option.range.to}
              label={option.label}
              handleSet={() => this.handleSet(option.range)}
            />
          ))}
          <hr
            css={css`
              border-top: 2px solid ${colors.gray30};
              margin: 0;
            `}
          />
          <div
            className="condition-range"
            css={css`
              padding: 15px 10px 0;
              color: #999;
              input.error {
                border: 1px solid ${colors.red50};
                color: ${colors.red50};
              }
            `}
          >
            <div
              className="field"
              css={css`
                display: inline-block;
                position: relative;
              `}
            >
              <input
                value={from ? from : ''}
                onChange={(e) => this.handleChange(e.target.value, 'from')}
                className={errorClass()}
                css={css`
                  width: 80px;
                  border: 1px solid #999;
                  border-radius: 2px;
                  padding: 3px 5px;
                  margin: 0;
                `}
              />
              <div
                className="annotation"
                css={css`
                  text-align: right;
                  color: #999;
                  font-size: 12px;
                `}
              >
                ({annotation})
              </div>
            </div>
            <span
              className="divider"
              css={css`
                margin: 5px 5px 0 5px;
                display: inline-block;
                vertical-align: top;
              `}
            >
              −
            </span>
            <div
              className="field"
              css={css`
                display: inline-block;
                position: relative;
              `}
            >
              <input
                value={to ? to : ''}
                onChange={(e) => this.handleChange(e.target.value, 'to')}
                className={errorClass()}
                css={css`
                  width: 80px;
                  border: 1px solid #999;
                  border-radius: 2px;
                  padding: 3px 5px;
                  margin: 0;
                `}
              />
              <div
                className="annotation"
                css={css`
                  text-align: right;
                  color: #999;
                  font-size: 12px;
                `}
              >
                ({annotation})
              </div>
            </div>
          </div>
        </OptionDropdown>
      </div>
    )
  }
}
